import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, ArrowRight, ArrowLeft } from "lucide-react";
import { getAbout } from "../api/about";
import styles from "./About.module.css";

export default function About() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    getAbout()
      .then(setAbout)
      .catch(() => {});
  }, []);

  return (
    <div className={styles.page}>
      <section className={styles.body}>
        <Link to="/" className={styles.homeBtn}>
          <ArrowLeft size={14} />
          Back to Home
        </Link>
        <div className={styles.bodyInner}>
          {about?.image && (
            <div className={styles.photoWrap}>
              <img
                src={about.image}
                alt={about.name || "Build With Mak"}
                className={styles.photo}
              />
            </div>
          )}
          <div className={styles.story}>
            {about?.name && (
              <>
                <p className={styles.role}>Owner / Software Developer</p>
                <h2 className={styles.name}>{about.name}</h2>
              </>
            )}
            {about?.tagline && (
              <p className={styles.tagline}>{about.tagline}</p>
            )}
            {about?.story && <p className={styles.storyText}>{about.story}</p>}
          </div>
        </div>
      </section>

      {(about?.email || about?.phone) && (
        <section className={styles.contact}>
          <div className={styles.contactInner}>
            <h2 className={styles.contactTitle}>Get in Touch</h2>
            <div className={styles.contactLinks}>
              {about.email && (
                <a
                  href={`mailto:${about.email}`}
                  className={styles.contactItem}
                >
                  <Mail size={18} />
                  {about.email}
                </a>
              )}
              {about.phone && (
                <a href={`tel:${about.phone}`} className={styles.contactItem}>
                  <Phone size={18} />
                  {about.phone}
                </a>
              )}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
